module.exports = __webpack_public_path__ + "static/media/About-01.f9434cf4.jpg";